import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone! I’m <span className="purple">Ricardo Marinho</span>{" "}
            from <span className="purple">Brazilia, Brazil</span>.
            <br />
            I’m currently working as a{" "}
            <span className="purple">ETL intern</span> at{" "}
            <span className="purple">Ministery of the Cities</span>.
            <br />
            <br />
            Outside of coding, I love engaging in activities that keep me
            creative and inspired:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games 🎮
            </li>
            <li className="about-activity">
              <ImPointRight /> Playing at the guitar
            </li>
            <li className="about-activity">
              <ImPointRight /> Study programming languagens
            </li>
            <li className="about-activity">
              <ImPointRight /> Study for database certification
            </li>
          </ul>

          <br />
          <p style={{ color: "rgb(155 126 172)" }}>
            "If I don't die of love, let art kill me!"{" "}
          </p>
          <footer className="blockquote-footer">Sid</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
